module.exports = __webpack_public_path__ + "img/partido-democratico-somos-peru.734b1d31.png";